<template>
  <section class="content-plans">
    <div class="content-plans-itens">
      <Breadcrumb :links="links" />
      <div class="content-plans-itens-body">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3">
            <router-link
              tag="a"
              :to="{ name: 'RegisterSpecialty' }"
              class="content--card-register"
              style="min-height: 200px"
            >
              <img
                class="img-fluid"
                src="@/assets/img/image-plus.png"
                alt="image plus"
                title="image plus"
              />
            </router-link>
          </div>
          <template v-if="hasSpecialties">
            <div
              class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3"
              v-for="specialty in specialties"
              :key="specialty.id"
            >
              <CardSpecialty :specialty="specialty" />
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import CardSpecialty from "@/views/Professional/components/CardSpecialty";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Profissional",
          routerName: "Professional",
        },
        {
          name: "Listar Especialidades",
          routerName: "ListSpecialties",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      specialties: "Professional/specialties",
    }),
    hasSpecialties() {
      return (
        this.specialties &&
        Array.isArray(this.specialties) &&
        this.specialties.length > 0
      );
    },
  },
  components: {
    Breadcrumb,
    CardSpecialty,
  },
  methods: {
    ...mapActions("Professional", ["consultSpecialties"]),
  },
  mounted() {
    this.consultSpecialties();
  },
};
</script>
